export default {
    events: {
        title: 'Event',
        date: 'Date',
        time: 'Time',
        manager: 'Customer',
        lineManager: 'Line manager',
        responsible: 'Employee',
        participants: 'Event participants',
        project: 'Related to project',
        person: 'Related to person',
        contact: 'Contact person',
        schedule: 'Scheduled',
        company: 'Company',
        comment: 'Note',
        documentPick: 'Document',
        edit: 'Edit',
        cancel: 'Cancel',
        save: 'Save',
        transfer: 'Transfer',
        resultEdit: 'Edit document',
        saveShort: 'Save short result',
        saveEventResult:'Save event result',
        trainer: 'Trainer',
        dateFrom: 'From',
        dateTo: 'To',
        print: 'Print',
        create: {
            type: 'Type',
            title: 'Schedule an event with the person: %(person)s',
            titleEnter: 'Enter an document for the person: %(person)s',
            titlePick: 'Pick an document from DB for the person: %(person)s',
            startTime: 'Start time',
            endTime: 'End Time',
            responsible: 'Responsible for the event (enters result)',
            company: 'Company',
            employee: 'Company employee',
            participants: 'Event participants',
        },
        types: {
            PhoneContact: 'Conversation',
            EmplInterview: 'Interview with recruiter',
            Client: {
                true: 'Interview with line manager',
                false: 'Interview with the client'
            }
        },
        enterResult: 'Enter event\'s result',
        isHappened: 'Did event happened?',
        appreciate: 'Appreciate the person',
        shortResult: 'Short result',
        reason: 'Reason',
        percent: '% of conformity',
        formDocumentResult: 'Fill document form',
        formDocumentEdit: 'Edit document form',
        formDocumentEditCancel: 'Cancel',
        formResult: 'Fill form',
        resultFromDisk: 'File',
        freeFormResult: 'Free form',
        result: 'Result',
        document: 'Document',
        fillResult: 'Fill short result',
        fillReason: 'Fill aborted result reason',
        unselectResult: 'Unselect result type button',
        good: 'Positive',
        bad: 'Negative',
        neutral: '50/50',
        simultaneously_edit: "You can not simultaneously edit the event and make the event's result",
        allday: 'All day',
        tookPlaceRadio: {
            Yes: "Took place",
            No: "Didn't take place"
        },
        formNotSet: 'Form for this event doesnt support in Web-interface',
        fill_required_fields: 'Fill required fields in Event',
        dateDismiss: 'Date of dismiss',
        passedProbation: 'Passed probation',
        didntPass: 'Didn\'t pass',
        startWorking: 'Start working',
        didntStart: 'Didn\'t start',
        endOfProbation: 'End of probation',
        start: 'Start',
        salary: 'Salary',
        gonorar: 'Fee',
        workToDate: 'End date',
        comeToWorkDate: 'Start date of work',
        positionName: 'Position',
        organization: 'Organization',
        department: 'Department',
        workPlace: 'Место работы',
        feeOfAgency: 'Fee of recruitment agency',
        additionaly: 'Additionaly',
        state: 'State',
        stage: 'Stage',
        whoTrudo: 'Who made the placement',
    }
};
